import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { useNavigate  } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { fetchPersonDetails } from "../actions";

/*** 
@purpose : Functional component
@Parameter : {props}
**/
function PersonSidebar(props) {
  const [isOpen, setIsOpen] = useState(false);
  const [id, setId] = useState("");
  const [lang] = useTranslation("language");
  const path = window.location.pathname;
  const navigate = useNavigate();

  useEffect(() => {
    async function initPersonSidebar() {
      try {
        let id;
        let url = window.location.href;
        id = unescape(url).split("?personId=")[1];
        setId(props.id);
      } catch (error) {
        console.error("Error initializing person sidebar:", error);
      }
    }
    
    initPersonSidebar();
  }, [props.id]);

  /*** 
  @purpose : Change route
  @Parameter : {e, page}
  **/
  const changeRoute = (e, page) => {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    navigate(page);
  };

  /*** 
  @purpose : Sidebar toggle
  @Parameter : {}
  **/
  const personSidebar = () => {
    setIsOpen(!isOpen);
    isOpen
      ? document.body.classList.remove("orgsidebar-collapse")
      : document.body.classList.add("orgsidebar-collapse");
  };

  return (
    <div className="org-sidebar">
      <div className="org-top">
        <div className="org-id">{id}</div>
        <div className="org-toggle" onClick={personSidebar}>
          <em className="bx bx-chevron-left"></em>
        </div>
      </div>
      <ul>
        <li>
          <a
            className={path === "/personInfo" || path === "/" ? "active" : ""}
            onClick={(e) => {
              changeRoute(e, "/personInfo");
            }}
          >
            <span className="org-icon">
              <img src="images/org9.svg" alt="Menu" />
            </span>
            <span className="item-name">{lang("PersonMenu.personInfo")}</span>
          </a>
        </li>
      </ul>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {};
};

export default connect(mapStateToProps, { fetchPersonDetails })(PersonSidebar);
